<!-- @format -->

<template>
	<pcp-selector-dialog
		:title="title"
		:value="selectedValue"
		:visible="selectorVisible"
		:label-key="labelKey"
		:multiple="multiple"
		@input-main="(value) => (selectedValue = value)"
		@fullscreen="handleFullscreen"
		@remove-select="setSelectRow"
		@open="handleOpen"
		@opened="handleOpened"
		@close="handleClose"
		@action-event="handleActionEvent"
	>
		<template #default="scope">
			<pcp-selector-panel
				ref="panel"
				v-bind="scope"
				:height="actualHeight"
				:is-auth="isAuth"
				:org-id="orgId"
				:party-type-id="partyTypeId"
				:current-org-id="currentOrgId"
				:pk-key="store === 'bind' ? 'name' : 'id'"
				:script="script"
				:form-data="formData"
				:is-use-scope="isUseScope"
				@selected="(value) => (selectedValue = value)"
			/>
		</template>
	</pcp-selector-dialog>
</template>
<script>
	import PcpSelectorPanel from './panel';
	import PcpSelectorDialog from '@/p-components/pcp-selector-dialog/dialog';
	import { $utils } from '@/utils/publicUtils';

	export default {
		components: {
			PcpSelectorDialog,
			PcpSelectorPanel,
		},

		props: {
			// 所有字段数据,(包含主主子表)
			formData: [Object, Array],
			// 是否可见
			visible: Boolean,
			// 是否启用范围
			isUseScope: {
				type: Boolean,
				default: false,
			},
			partyTypeId: [String, Number],
			currentOrgId: [String, Number],
			script: String,
			isAuth: {
				type: Boolean,
				default: false,
			},
			orgId: [String, Number],
			// 标题
			title: {
				type: String,
				default() {
					return '角色选择器';
				},
			},
			// Dialog CSS 中的 margin-top 值
			marginTop: {
				type: String,
				default: '15vh',
			},
			// 宽
			width: {
				type: String,
				default: '60%',
			},
			// 高
			height: {
				type: String,
				default: '345px',
			},
			// 是否可以通过点击 modal 关闭 Dialog
			closeOnClickModal: {
				type: Boolean,
				default: false,
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			closeOnPressEscape: {
				type: Boolean,
				default: false,
			},
			// 是否显示关闭按钮
			showClose: {
				type: Boolean,
				default: true,
			},
			// 关闭前的回调，会暂停 Dialog 的关闭
			beforeClose: {
				type: Function,
			},
			// 是否为全屏 Dialog
			fullscreen: {
				type: Boolean,
				default: false,
			},
			// 唯一存储的值
			valueKey: {
				type: String,
				default: 'id',
			},
			// 展示的值
			labelKey: {
				type: [String, Function],
				default: 'name',
			},
			store: {
				type: String,
				default: 'id',
			},
			value: {
				type: [Object, Array],
				default() {
					// return this.multiple ? [] : {};
				},
			},
			// 按钮清空并关闭
			cleanClose: {
				type: Boolean,
				default: false,
			},
			// 按钮组
			buttons: {
				type: Array,
			},
			confirmButtonText: {
				type: String,
				default() {
					return '选择';
				},
			},
			cleanButtonText: String,
			cancelButtonText: String,
			// 是否多选
			multiple: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selectorVisible: false,
				selectedValue: this.multiple ? [] : {},
				dialogFullscreen: this.fullscreen,
			};
		},
		computed: {
			actualHeight() {
				return this.dialogFullscreen ? this.getFullscreenDialogHeight() : this.height;
			},
		},
		watch: {
			visible: {
				handler(val) {
					this.selectorVisible = val;
					// const valueData = this.multiple ? this.value : $utils.isArray(this.value) ? this.value : [this.value];
					// this.selectedValue =
					// 	this.store === 'bind'
					// 		? valueData.map((v) => {
					// 				const name = this.isString(v) ? v : v[this.valueKey];
					// 				const data = {};
					// 				data[this.valueKey] = name;
					// 				return data;
					// 		  })
					// 		: valueData;
				},
				immediate: true,
			},
			fullscreen(val) {
				this.dialogFullscreen = val;
			},
			value() {
				this.selectedValue = this.value;
			},
		},
		beforeUnmount() {
			this.selectedValue = null;
		},
		methods: {
			getFullscreenDialogHeight() {
				const h = document.documentElement.clientHeight || document.body.clientHeight;
				return `${h - 60 - 90}px`;
			},
			isString(v) {
				const Booleans = $utils.isString(v);
				return Booleans;
			},
			setSelectRow() {
				setTimeout(() => {
					this.$refs['panel'].setSelectRow();
				}, 10);
			},
			handleFullscreen(val) {
				this.dialogFullscreen = val;
			},
			// 打开窗口
			handleOpen() {
				this.$emit('open');
			},
			// 打开窗口后
			handleOpened() {
				this.$emit('opened');
			},
			handleClose(visible) {
				this.$emit('close', visible);
			},
			handleActionEvent(key) {
				if (key === 'clean') {
					this.setSelectRow();
				}
				if (key === 'cancel') {
					this.selectedValue = [];
				}
				// 备注：回调函数会走两次，先注释掉
				// this.$emit('action-event', key, data);
			},
		},
	};
</script>
